import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import { DarkModeService } from '../../services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss']
})
export class DarkModeToggleComponent implements OnInit {
  darkMode$: Observable<boolean> = this.darkModeService.darkMode$;
  darkModeActive: boolean;

  constructor(private darkModeService: DarkModeService) {}

  onToggle(): void {
      this.darkModeService.toggle();
  }

  ngOnInit() {
      this.darkMode$.subscribe(res => this.darkModeActive = res);
  }
}
